import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-not-allowed-page',
  templateUrl: './not-allowed-page.component.html',
  styleUrls: ['./not-allowed-page.component.scss']
})
export class NotAllowedPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
